module.exports = "<div class=\"row title p-v-sm\"> <div class=\"col-md-12 p-h-lg p-v m-b-xs\"> <h3 class=\"text-block no-margin exo text-azul\"> {{ reviewTVM.mainLabel }} <span ng-show=!reviewTVM.isTeacher()> - {{ reviewTVM.teacher }} </span> </h3> <md-button aria-label ng-show=reviewTVM.inExecution() class=\"btn btn-fw btn-success right\" ng-click=addActivity()> Finalizar ejecución </md-button> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/u-faculty/workplan/consolidationCP/teachingDevelopment/listTeacherJobsView/header-course.html
// module id = 661
// module chunks = 0